import { AffiliationRelations } from '@generated/graphql';
/* keep this synchronized with account-service */

export const RespSinglePrimaryBeneficiaryRelations = [
  AffiliationRelations.Child,
  AffiliationRelations.Grandchild,
  AffiliationRelations.NephewNiece,
  AffiliationRelations.Sibling,
  AffiliationRelations.Other,
];

export const RespFamilyPrimaryBeneficiaryRelations = [
  AffiliationRelations.Child,
  AffiliationRelations.Grandchild,
  AffiliationRelations.Sibling,
];

export const JointAccountHolderRelations = [
  AffiliationRelations.Spouse,
  AffiliationRelations.CommonLaw,
];
